import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/*
 * System → Support → Support email: ESPY_EMAIL_SUPPORT, the inbox new tickets and
 * unassigned ticket replies are emailed to. ESPY_EMAIL (the sending account)
 * stays in the ConfigMap — the mailer signs in with it once, at start.
 */
const GROUPS = [
  { key: 'email', title: 'Support', sub: 'Ticket emails' },
]

export function EmailSettingsV2() {
  return (
    <SettingsSectionV2
      title="Support email"
      intro="Where support emails go. A value saved here replaces the ConfigMap one and works without a restart."
      groups={GROUPS}
      saveNote={() => 'Used from the next ticket email.'}
    />
  )
}
